import React, { useEffect, useState } from 'react'
import Nav from '../../components/Nav'
import DinamicTable from '../../components/DinamicTable';
import DashboardSidebar from '../../components/DashboardSidebar';
import ApiService from '../../services/ApiService';

const UserList = () => {

    const [active, setActive] = useState(true);
    const [users, setUsers] = useState([]);
    const [filter, setFilter] = useState({page:1, pages:0, limit:5, isLoading:false, search:''})

    const tableColumns = ["#", "Username", "Role","Action"];

    const getUsers = async () => {
        try {
            setFilter((prev)=>{return{...prev,isLoading:true}});
            const response = await ApiService.get(`/cms/auth/users?page=${filter?.page}&limit=${filter?.limit}&username=${filter?.search}`);
            setFilter((prev)=>{return{...prev,pages:response?.totalPages}});
            setUsers(response?.users?.map(user=>{return{_id:user?._id, username:user?.username, role:user?.role}}) || []);
        } catch (err) {
            console.error("Error fetching tasks:", err);
        } finally { 
             setFilter((prev)=>{return{...prev,isLoading:false}});
        }
    };

    useEffect(()=>{
        if(filter?.isLoading==false){
            getUsers();
        }
    },[filter?.page, filter?.search]);

    return (
        <div className="tyn-root dashboard">
            <Nav />
            <div className="tyn-content tyn-content-full-height tyn-chatbot tyn-chatbot-page has-aside-base">
                <DashboardSidebar active='User List' setter={setActive} />
                <div className={`tyn-main tyn-content-inner ${active && 'main-shown' || ''}`} id="tynMain">
                <ul className="tyn-list-inline d-md-none translate-middle position-absolute start-50 z-1">
                        <li>
                            <button className="btn btn-icon btn-pill btn-white js-toggle-main" onClick={() => setActive(false)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                                    <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
                                </svg>
                            </button>
                        </li>
                    </ul>
                    
                    <DinamicTable data={users} title="User List" tableColumns={tableColumns} addLink="/dashboard/user/add" editLink="/dashboard/user/" filter={filter} setFilter={setFilter}/>
                </div>
            </div>
        </div>
    )
}

export default UserList